import {
  SplitBillRemaining,
  SplitBillRepository,
  SplitBillTokenDto,
} from './repository/SplitBillRepository';
import { fetchGet, fetchPost, fetchPut } from 'utils/services/fetch';
import apiUrlProvider, {
  UPDATE_TOTAL_SPLITBILL,
  REQUEST_REMAINING_SPLIT_BILL,
  GET_ITEMS,
  SPLIT_ITEMS,
  UPDATE_TRANSFER,
  SEND_TRANSFER,
  CONFIRM_SPLIT_PAYMENT,
  PAY_OTHER_ITEMS,
  UPDATE_PAY_OTHER,
} from 'constants/api-endpoints';

interface Item {
  pid: string;
  name: string;
  amount: number;
}
interface ResPayOtherItems {
  data: Item[];
}

export class SplitBillService extends SplitBillRepository {
  async updatePayOtherItems(
    token: string,
    payload: { currentSplitPid: string; itemPids: string[] },
  ): Promise<string> {
    return fetchPut(apiUrlProvider.get(UPDATE_PAY_OTHER), payload, {
      isAuth: true,
      token,
    });
  }

  async getPayOtherItems(token: string): Promise<ResPayOtherItems> {
    return fetchGet(
      apiUrlProvider.get(PAY_OTHER_ITEMS),
      {},
      {
        isAuth: true,
        token,
      },
    );
  }

  async confirm(token: string) {
    return fetchPost(
      apiUrlProvider.get(CONFIRM_SPLIT_PAYMENT),
      {},
      {
        isAuth: true,
        token,
      },
    );
  }

  async sendTransfer(token: string) {
    return fetchPost(
      apiUrlProvider.get(SEND_TRANSFER),
      {},
      {
        isAuth: true,
        token,
      },
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async updateTransfer(token: string, data: any) {
    return fetchPut(apiUrlProvider.get(UPDATE_TRANSFER), data, {
      isAuth: true,
      token,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async splitByItem(token: string, items: any): Promise<any> {
    return fetchPost(apiUrlProvider.get(SPLIT_ITEMS), items, {
      isAuth: true,
      token,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getItems(token: string): Promise<any> {
    return fetchGet(
      apiUrlProvider.get(GET_ITEMS),
      {},
      {
        isAuth: true,
        token,
      },
    );
  }

  async updateTotalSplit(token: string, totalBillSplit: number): Promise<SplitBillTokenDto> {
    const headSplitToken = await fetchPut(
      apiUrlProvider.get(UPDATE_TOTAL_SPLITBILL),
      { total: totalBillSplit },
      {
        isAuth: true,
        token,
      },
    );

    return headSplitToken;
  }

  async getChildSplitToken(token: string): Promise<SplitBillTokenDto> {
    const headSplitToken = await fetchPost(
      apiUrlProvider.get(UPDATE_TOTAL_SPLITBILL),
      {},
      {
        isAuth: true,
        token,
      },
    );

    return headSplitToken;
  }

  async getRemaining(token: string): Promise<SplitBillRemaining> {
    return fetchGet(
      apiUrlProvider.get(REQUEST_REMAINING_SPLIT_BILL),
      {},
      {
        isAuth: true,
        token,
      },
    );
  }
}
